
export const AuthModal = {
    props: {
        value: { type: Boolean, required: true },
    },
};
export default AuthModal;
